/**
 * Fetch browser safe config from the server
 * @module services/config
 */
import request from 'services/request'
import { fromJS } from 'immutable'
import get from 'lodash/get'
import { createAuthorization } from '../auth'

export const STATUS_PUBLISHED = 0
export const STATUS_UNPUBLISHED = 1
export const STATUS_NEEDS_REVIEW = 2

/**
 * Get a list of comments
 * @param {object} options The options
 * @param {string} options.server The server url
 * @param {Map} options.auth An immutable map with the auth data
 * @param {number} options.offset The query offset
 * @param {number} options.limit The query limit
 */
export async function getCommentsList (options = {}) {
  const { server, auth, offset, limit, uid, contentId, status } = options
  const res = await request
    .get(`${server}/v1/admin/comments/list`)
    .query({
      offset,
      limit,
      uid,
      contentId,
      status,
    })
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')
  return fromJS(get(res, 'body', {}))
}

/**
 * Update a comment, allows partial update
 * @param {object} options The options
 * @param {string} options.server The server url
 * @param {Map} options.auth An immutable map with the auth data
 * @param {number} options.id The comment id
 * @param {Map} options.data The PUT request body
 */
export async function update (options = {}) {
  const { server, auth, id, data } = options
  const res = await request
    .put(`${server}/v1/comments/${id}`)
    .send(data.toJS())
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')
  return fromJS(get(res, 'body', {}))
}
